import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { cn } from '../lib/utils';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Accueil',
    href: '/'
  }, {
    name: 'À propos de Nous',
    href: '/a-propos'
  }, {
    name: 'Alimentation',
    href: '/alimentation',
    hasDropdown: true
  }, {
    name: 'Boisson',
    href: '/boisson'
  }, {
    name: 'Maison et Décoration',
    href: '/maison'
  }, {
    name: 'Electronique',
    href: '/electronique'
  }];
  return <header className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-300', isScrolled ? 'bg-brand-green shadow-lg py-3' : 'bg-brand-green py-5')} data-id="element-86">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 flex items-center justify-between" data-id="element-87">
        {/* Logo Area */}
        <div className="flex flex-col" data-id="element-88">
          <Link to="/" className="flex items-center gap-1" data-id="element-89">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-brand-red w-8 h-8" data-id="element-90">
              <path d="M2 22L12 2L22 22H17L12 12L7 22H2Z" fill="currentColor" data-id="element-91" />
            </svg>
            <span className="text-brand-cyan font-heading font-bold text-2xl md:text-3xl tracking-tight whitespace-nowrap" data-id="element-92">
              AVENIR 2000
            </span>
          </Link>
          <span className="text-white/80 text-[10px] uppercase tracking-wider font-medium mt-0.5" data-id="element-93">
            Le choix, la qualité, au meilleur prix
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-94">
          {navLinks.map(link => {
          const isActive = location.pathname === link.href;
          return <Link key={link.name} to={link.href} className={cn('text-sm font-semibold transition-colors flex items-center gap-1', isActive ? 'text-brand-gold' : 'text-white hover:text-brand-gold')} data-id="element-95">
                {link.name}
                {link.hasDropdown && <ChevronDown className="w-4 h-4" data-id="element-96" />}
              </Link>;
        })}
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-97">
          {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-98" /> : <Menu className="w-6 h-6" data-id="element-99" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-brand-green border-t border-white/10 shadow-xl" data-id="element-100">
          <nav className="flex flex-col px-4 py-4 space-y-4" data-id="element-101">
            {navLinks.map(link => {
          const isActive = location.pathname === link.href;
          return <Link key={link.name} to={link.href} className={cn('text-base font-semibold transition-colors flex items-center justify-between', isActive ? 'text-brand-gold' : 'text-white')} onClick={() => setMobileMenuOpen(false)} data-id="element-102">
                  {link.name}
                  {link.hasDropdown && <ChevronDown className="w-4 h-4" data-id="element-103" />}
                </Link>;
        })}
          </nav>
        </div>}
    </header>;
}